import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum } from '../../enums'

import {
  InstanceIndexServiceConfigForm,
  InstanceManagementForm,
  InstanceSearchServiceConfigForm,
  InstanceServiceConfigForm,
} from '../../views'

import { ROUTER_CONSTS } from '../router.consts'

const NAMES = ROUTER_CONSTS.routes[FeatureIdEnum.INSTANCE_MANAGEMENT]

const PATHS = {
  root: 'management',
  service: `:${ROUTER_CONSTS.params.service}/:${ROUTER_CONSTS.params.child}?`,
  search: 'search',
  index: 'index',
}

const featureId = FeatureIdEnum.INSTANCE_MANAGEMENT

export const INSTANCE_MANAGEMENT_ROUTES: AppRouteConfig[] = [
  {
    name: NAMES.root,
    path: PATHS.root,
    component: InstanceManagementForm,
    meta: {
      featureId,
    },
    children: [
      {
        name: NAMES.search,
        path: PATHS.search,
        component: InstanceSearchServiceConfigForm,
        meta: {
          featureId,
        },
      },
      {
        name: NAMES.index,
        path: PATHS.index,
        component: InstanceIndexServiceConfigForm,
        meta: {
          featureId,
        },
      },
      {
        name: NAMES.service,
        path: PATHS.service,
        component: InstanceServiceConfigForm,
        meta: {
          featureId,
        },
      },
    ],
  },
]
